import React from 'react';

function XIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="site-footer-svg-icon">
            <path
                fill="currentColor"
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            />
        </svg>
    );
}

function InstagramIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="site-footer-svg-icon">
            <path
                fill="currentColor"
                d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.97.24 2.43.403a4.92 4.92 0 0 1 1.67 1.087 4.92 4.92 0 0 1 1.087 1.67c.163.46.349 1.26.403 2.43.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.97-.403 2.43a4.92 4.92 0 0 1-1.087 1.67 4.92 4.92 0 0 1-1.67 1.087c-.46.163-1.26.349-2.43.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.97-.24-2.43-.403a4.92 4.92 0 0 1-1.67-1.087 4.92 4.92 0 0 1-1.087-1.67c-.163-.46-.349-1.26-.403-2.43C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.054-1.17.24-1.97.403-2.43a4.92 4.92 0 0 1 1.087-1.67 4.92 4.92 0 0 1 1.67-1.087c.46-.163 1.26-.349 2.43-.403C8.416 2.175 8.796 2.163 12 2.163zm0 1.802c-3.15 0-3.527.012-4.765.07-1.01.046-1.56.215-1.924.357a3.2 3.2 0 0 0-1.157.754 3.2 3.2 0 0 0-.754 1.157c-.142.364-.311.914-.357 1.924-.058 1.238-.07 1.615-.07 4.765s.012 3.527.07 4.765c.046 1.01.215 1.56.357 1.924.17.437.398.8.754 1.157.357.357.72.585 1.157.754.364.142.914.311 1.924.357 1.238.058 1.615.07 4.765.07s3.527-.012 4.765-.07c1.01-.046 1.56-.215 1.924-.357a3.2 3.2 0 0 0 1.157-.754 3.2 3.2 0 0 0 .754-1.157c.142-.364.311-.914.357-1.924.058-1.238.07-1.615.07-4.765s-.012-3.527-.07-4.765c-.046-1.01-.215-1.56-.357-1.924a3.2 3.2 0 0 0-.754-1.157 3.2 3.2 0 0 0-1.157-.754c-.364-.142-.914-.311-1.924-.357-1.238-.058-1.615-.07-4.765-.07zm0 3.568a4.467 4.467 0 1 1 0 8.934 4.467 4.467 0 0 1 0-8.934zm0 1.802a2.665 2.665 0 1 0 0 5.33 2.665 2.665 0 0 0 0-5.33zm5.338-3.205a1.04 1.04 0 1 1-2.08 0 1.04 1.04 0 0 1 2.08 0z"
            />
        </svg>
    );
}

const iconMap = {
    x: XIcon,
    instagram: InstagramIcon,
};

export function SocialIcon({ id }) {
    const Icon = iconMap[id];
    if (!Icon) return null;
    return <Icon />;
}

export default SocialIcon;